
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/how-to/mint-custom-metadata",
      function () {
        return require("private-next-pages/docs/how-to/mint-custom-metadata.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/how-to/mint-custom-metadata"])
      });
    }
  